export default __webpack_public_path__ + "static/media/cat_w_gradient.93c47f30.png";